module.exports = __webpack_public_path__ + "static/media/logout.882c8bb6.svg";